export const INFO_CONTENT = {
  "tentang-kami": {
    eyebrow: "Tentang Kami",
    title: "Toko kecil gelang beads buatan tangan",
    lead:
      "Zoya Beads baru mulai. Semua gelang yang kamu lihat di sini kami rangkai sendiri, satu per satu, dalam jumlah terbatas.",
    sections: [
      {
        heading: "Cara kami bekerja",
        body:
          "Kami memilih beads, menyusun urutan warnanya, mengukur elastis atau rantai, lalu memastikan simpul dan pengaitnya rapi sebelum dikemas. Tidak ada produksi mesin.",
      },
      {
        heading: "Material",
        body:
          "Kristal crackle, batu kaca, mutiara kaca, obsidian, serta charm dan rondelle berlapis emas atau perak. Butir yang retak atau tidak seragam kami sisihkan.",
      },
      {
        heading: "Jumlah terbatas",
        body:
          "Stok beads yang kami punya tidak selalu bisa dibeli ulang, jadi tiap desain hanya dibuat beberapa buah. Kalau habis, biasanya kami buat rangkaian baru.",
      },
      {
        heading: "Pemesanan",
        body:
          "Website ini hanya katalog. Pilih gelang yang kamu suka, lalu kirim daftarnya lewat WhatsApp — ketersediaan, ongkir, dan pembayaran dikonfirmasi di chat.",
      },
    ],
  },
  kontak: {
    eyebrow: "Kontak",
    title: "Hubungi kami",
    lead:
      "Ada pertanyaan soal ukuran, ketersediaan, atau status pesanan? Kami balas pada hari kerja, 09.00–17.00 WIB.",
    sections: [
      { heading: "WhatsApp", body: "+62 851-5783-3612 — semua pesanan diproses lewat WhatsApp. Kirim nomor pesanan kamu untuk konfirmasi pembayaran." },
      { heading: "Ukuran khusus", body: "Butuh lingkar gelang lebih besar atau lebih kecil? Sebutkan saat chat, biasanya bisa kami sesuaikan." },
    ],
  },
  "kebijakan-pengiriman": {
    eyebrow: "Kebijakan",
    title: "Kebijakan Pengiriman",
    lead:
      "Pesanan diproses dalam 1–2 hari kerja setelah pembayaran dikonfirmasi lewat WhatsApp.",
    sections: [
      { heading: "Biaya", body: "Ongkos kirim mengikuti tarif ekspedisi sesuai alamat kamu dan dikonfirmasi lewat WhatsApp sebelum pesanan dikerjakan." },
      { heading: "Estimasi", body: "Pulau Jawa 2–3 hari kerja, luar Jawa 3–6 hari kerja setelah paket dikirim." },
      { heading: "Pelacakan", body: "Nomor resi kami kirim lewat WhatsApp segera setelah paket diserahkan ke kurir." },
      { heading: "Kemasan", body: "Setiap gelang dikemas dalam pouch dan kotak kaku, jadi bisa langsung diberikan sebagai hadiah." },
    ],
  },
  "kebijakan-pengembalian": {
    eyebrow: "Kebijakan",
    title: "Kebijakan Pengembalian",
    lead:
      "Kami ingin kamu benar-benar menyukai gelangmu. Pengembalian dapat diajukan dalam 7 hari sejak paket diterima.",
    sections: [
      { heading: "Syarat", body: "Produk belum dipakai, lengkap dengan kemasan asli, serta disertai foto dan nomor pesanan." },
      { heading: "Cacat produksi", body: "Jika ada butir yang lepas atau elastis bermasalah, kami perbaiki atau ganti tanpa biaya, termasuk ongkos kirim." },
      { heading: "Tukar ukuran", body: "Penyesuaian lingkar gelang gratis satu kali; ongkos kirim ditanggung pembeli." },
      { heading: "Pengembalian dana", body: "Dana dikembalikan ke rekening pengirim dalam 3–5 hari kerja setelah produk kami terima dan diperiksa." },
    ],
  },
  privasi: {
    eyebrow: "Legal",
    title: "Kebijakan Privasi",
    lead:
      "Kami hanya mengumpulkan data yang diperlukan untuk memproses dan mengirim pesananmu.",
    sections: [
      { heading: "Data yang kami simpan", body: "Kami tidak menyimpan data apa pun dari website ini. Nama, nomor telepon, dan alamat pengiriman hanya kamu kirim langsung lewat chat WhatsApp saat memesan." },
      { heading: "Penggunaan data", body: "Data dari chat hanya kami pakai untuk memproses dan mengirim pesananmu. Kami tidak menjual data ke pihak ketiga." },
      { heading: "Wishlist", body: "Daftar pilihan dan favorit disimpan di penyimpanan lokal peramban kamu sendiri, tidak dikirim ke server kami." },
      { heading: "Hak kamu", body: "Kamu bisa menghapus daftar pilihan dan favorit kapan saja dengan membersihkan data peramban, atau minta penghapusan data chat lewat WhatsApp." },
    ],
  },
  "syarat-ketentuan": {
    eyebrow: "Legal",
    title: "Syarat & Ketentuan",
    lead:
      "Dengan berbelanja di Zoya Beads, kamu menyetujui ketentuan berikut.",
    sections: [
      { heading: "Harga", body: "Semua harga tertera dalam Rupiah (IDR) dan sudah termasuk pajak yang berlaku. Harga dapat berubah tanpa pemberitahuan." },
      { heading: "Pesanan", body: "Website ini katalog; pesanan dianggap sah setelah dikonfirmasi lewat WhatsApp dan pembayaran diterima. Kami berhak membatalkan bila terjadi kesalahan harga atau stok beads habis." },
      { heading: "Karakter produk", body: "Karena dirangkai tangan, variasi kecil pada warna dan posisi beads adalah wajar dan bukan merupakan cacat." },
      { heading: "Hak kekayaan intelektual", body: "Seluruh foto, nama koleksi, dan materi di situs ini milik Zoya Beads dan tidak boleh digunakan tanpa izin." },
    ],
  },
};
